import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "@popperjs/core/dist/umd/popper.min.js"
import "bootstrap/dist/js/bootstrap.min.js"
import "bootstrap-icons/font/bootstrap-icons.css"
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export function wrapRootElement({ element }) {
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LfXNVMdAAAAAJuGQT2ZOV0AcdsOVcUitc7k79Nb">
            {element}
        </GoogleReCaptchaProvider>
    )
}